module.exports = __webpack_public_path__ + "img/jacobsen_Bruken_av_kontraster.0b371600.jpg";